import workService from '@api/modules/workService';
import i18n from '@config/i18n/i18n';

export default {
  state: {
    works: [],
    work: {},
  },
  mutations: {
    setWorks(state, works) {
      state.works = works;
    },
    setWork(state, work) {
      state.work = work;
    },
  },
  actions: {
    getWorks({
      commit,
      state
    }, query) {
      workService.get(query).then(res => {
        commit('setWorks', res.data);
      }, err => {
        throw new Error(err);
      })
    },
    getWork({
      commit,
      state
    }, slug) {
      workService.get(slug).then(res => {
        let breadObject = {
          name: "Breadcrumbs",
          payload: {
            afterHero: false,
            current: res.data.title,
            elements: [{
              text: i18n.messages[i18n.locale].nav.cosa.title,
              url: '/' + i18n.locale + '/' + (i18n.messages[i18n.locale].nav.cosa.slug)
            }, {
              text: i18n.messages[i18n.locale].filters[res.data.type],
              url: '/' + i18n.locale + '/' + (i18n.messages[i18n.locale].nav.cosa.slug) + '?cat=' + res.data.type
            }]
          }
        };
        if (res.data.partials[0].name === 'HeroComponent') {
          breadObject.payload.afterHero = true;
          res.data.partials.splice(1, 0, breadObject);
        } else {
          res.data.partials.splice(0, 0, breadObject);
        };
        commit('setWork', res.data);
      }, err => {
        throw new Error(err);
      });
    },
  },
  getters: {
    getWorks: state => {
      return state.works
    },
    getWork: state => {
      return state.work
    },
    getWorkSlugByLocale: state => locale => {
      return state.work.slug[locale]
    },
  }
}